
import { computed, defineComponent, toRef } from "vue";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import NotificationStore from "@/store/notification";
import {
  GET_UNREAD_CONVERSATION,
  NOTIFICATION_STORE,
} from "@/store/notification/types";
import { IConversationUnreadCount } from "@/interfaces/iMessage";
import { ISms } from "@/interfaces/iSms";

export default defineComponent({
  name: "unread-count",
  components: {},
  props: {
    item: {
      type: Object as () => ISms,
      required: true,
    },
  },
  setup(props) {
    const item = toRef(props, "item");
    const store = useStore();
    getModule(NotificationStore);
    const notificationData = computed(() => {
      const key = `${NOTIFICATION_STORE}/${GET_UNREAD_CONVERSATION}`;
      return store.getters[key] as IConversationUnreadCount[];
    });
    const unreadCount = computed(() => {
      const data = notificationData.value.find(
        (e) => `${e.conversationId}` === `${item.value.webId}`
      );

      return data?.unReadCount ?? 0;
    });
    return {
      unreadCount,
    };
  },
});
